import React, { useState, useEffect } from "react";
import { useNavigate } from "react-router-dom";

const conditionOptions = [
  "Back Pain", "Fibromyalgia", "Knee Pain", "Arthritis",
  "Neuropathic Pain", "Migraines", "Chronic Pain",
  "Complex Regional Pain Syndrome", "Post-Surgical Pain", "Joint Pain",
  "Inflammatory Pain", "Musculoskeletal Pain"
];

export default function ProfilePage() {
  const [user, setUser] = useState(null);
  const [displayName, setDisplayName] = useState("");
  const [selectedConditions, setSelectedConditions] = useState([]);
  const [saving, setSaving] = useState(false);
  const navigate = useNavigate();

  useEffect(() => {
    const stored = localStorage.getItem("user");
    if (stored) {
      const parsed = JSON.parse(stored);
      setUser(parsed);
      setDisplayName(parsed.username || "");
      setSelectedConditions(parsed.conditions || []);
    }
  }, []);

  const handleSave = () => {
    if (!user) return;
    setSaving(true);
    const updated = {
      ...user,
      username: displayName,
      conditions: selectedConditions,
    };
    localStorage.setItem("user", JSON.stringify(updated));
    setUser(updated);
    setTimeout(() => setSaving(false), 800);
  };

  const handleLogout = () => {
    localStorage.removeItem("user");
    setUser(null);
    navigate("/");
  };

  const toggleCondition = (condition) => {
    setSelectedConditions((prev) =>
      prev.includes(condition)
        ? prev.filter((c) => c !== condition)
        : [...prev, condition]
    );
  };

  if (!user) {
    return (
      <div style={{ background: "#d1e8fd", display: "flex", flexDirection: "column", alignItems: "center"}}>
        {/* Top nav */}
        <div className="top-nav" style={{ width: "90%", maxWidth: "1020px" }}>
          <button
            className="nav-button nav-button-explore"
            onClick={() => navigate("/")}
          >
            Explore Database
          </button>
        </div>

        <div className="home-wrapper">
          <div className="home-container white-box" style={{ textAlign: "center" }}>
            <h2>You’re not signed in</h2>
            <button
              className="nav-button nav-button-explore"
              onClick={() => navigate("/register")}
            >
              Go to Register / Login
            </button>
          </div>
        </div>
      </div>
    );
  }

  return (
    <div style={{ background: "#d1e8fd", display: "flex", flexDirection: "column", alignItems: "center" }}>
      {/* Top nav */}
      <div className="top-nav" style={{ width: "90%", maxWidth: "1020px" }}>
        <button
          className="nav-button nav-button-explore"
          onClick={() => navigate("/")}
        >
          Explore Database
        </button>
        <button className="nav-button contact" onClick={handleLogout}>
          Logout
        </button>
      </div>

      {/* White content box */}
      <div className="home-wrapper">
        <div className="home-container white-box" style={{ textAlign: "center" }}>
          {/* Avatar */}
          <div className="profile-chip-avatar profile-avatar-lg">
            {displayName?.[0] || "U"}
          </div>


          <div style={{ fontSize: "1.2rem", fontWeight: "bold" }}>
            {displayName}
          </div>
          <div style={{ fontSize: "0.9rem", color: "#555" }}>{user.email}</div>

          {/* Name input */}
          <div className="search-container">
          <input
            type="text"
            className="search-input"
            value={displayName}
            onChange={(e) => setDisplayName(e.target.value)}
            placeholder="Display Name"
            style={{ marginTop: "1rem" }}
          />
          </div>

          {/* Conditions */}
          <h4 style={{ marginTop: "1.5rem" }}>Your Conditions</h4>
          <div style={{ display: "flex", flexWrap: "wrap", gap: "8px", justifyContent: "center" }}>
            {conditionOptions.map((condition) => {
              const selected = selectedConditions.includes(condition);
              return (
                <button
                  key={condition}
                  type="button"
                  onClick={() => toggleCondition(condition)}
                  style={{
                    padding: "8px 14px",
                    borderRadius: "20px",
                    border: selected ? "2px solid rgb(163, 187, 208)" : "2px solid #ccc",
                    backgroundColor: selected ? "#e3f2fd" : "#f5f5f5",
                    color: selected ? "#1976d2" : "#333",
                    fontWeight: "500",
                    cursor: "pointer",
                    transition: "all 0.2s ease",
                  }}
                >
                  {condition}
                </button>
              );
            })}
          </div>

          {/* Save button only */}
          <div style={{ display: "flex", justifyContent: "center", marginTop: "1rem" }}>
            <button
              onClick={handleSave}
              className="nav-button nav-button-explore"
              disabled={saving}
            >
              {saving ? "Saving..." : "Save Changes"}
            </button>
          </div>
        </div>
      </div>
    </div>
  );
}
